import classnames from 'classnames';
import React from 'react';

import '@eika/checkbox-style';

import Checkbox from './Checkbox';
import { CheckboxLabel } from './CheckboxLabel';
import { CheckboxGroupProps } from './types';

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
    className,
    options,
    label,
    sublabel,
    infoButton,
    externalLinkLabel,
    checkboxWrapperClassName,
    ...rest
}) => (
    <fieldset className={classnames('sgw-checkbox-group', className)} {...rest}>
        <CheckboxLabel
            label={label}
            sublabel={sublabel}
            infoButton={infoButton}
            externalLinkLabel={externalLinkLabel}
        />
        <div className={classnames('sgw-checkbox-group__content', checkboxWrapperClassName)}>
            {options.map((optionProps) => (
                <Checkbox {...optionProps} key={optionProps.id ?? optionProps.label} />
            ))}
        </div>
    </fieldset>
);

export default CheckboxGroup;
